var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('h2',[_vm._v("Partner")]),_c('PartnerDetails',{attrs:{"partner":_vm.partner}}),_c('pre',{directives:[{name:"show",rawName:"v-show",value:(_vm.debugMode),expression:"debugMode"}],staticClass:"debug"},[_vm._v(_vm._s(_vm.partner))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }